<app-page-header [heading]="'Notes'" [icon]="'fa-edit'" style="height:100px;"></app-page-header>

<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row col-lg-12">
    <div class="form-group col-lg-6">
      <label>Title</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="notes_data.title" class="form-control " name="title" type="text">
    </div>
    <div class="form-group col-lg-12">
      <label>Description</label><span class="text-danger">&nbsp;*</span>
      <textarea [(ngModel)]="notes_data.description" class="form-control " name="decription" rows="10"
                type="text"></textarea>
    </div>

  </div>
  <div class="clearfix"></div>
  <div class="row container">
    <div class="col-lg-7 pull-right">
      <button (click)="savenotes();" *ngIf="user_rights.ADD == '1'" class="btn btn-info btn-sm ng-star-inserted"
              type="button">&nbsp;Save&nbsp;
      </button>&nbsp;&nbsp;&nbsp;
      <button (click)="clearnotes();" *ngIf="user_rights.ADD == '1'" class="btn btn-danger btn-sm" type="button">&nbsp;Clear&nbsp;</button>
    </div>
  </div>
  <div class="clearfix"></div>
</div>

<div class="page-break">
  <div class="col-lg-12 row container">
    <div class="col-lg-8">
      <h4 class="list-header">Notes List</h4>
    </div>
    <div class="col-lg-4">
      <div class="row">
        <div class="input-group ">
          <input (keydown)="keyDownFunction($event)" [(ngModel)]="search_text" class="form-control" id="typeahead-http"
                 name="search_text"
                 placeholder="Press enter to search ..." style="height:31px" type="text">
          <div class="input-group-append">
            <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
              <i *ngIf="search_text != ''" class="fa fa-close"></i>
              <i *ngIf="search_text == ''" class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="this.status == 'Failed'"><span [hidden]="this.status == 'Success'"
                                                 style="color:red;font-size:13px;"> Sorry, suggestions could not be loaded.</span>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="">
    <table class="table tbl  table-hover table-striped  table-bordered">
      <thead>
      <tr>
        <th width="1%">Sl#</th>
        <th width="9%">Title</th>
        <th>Description</th>
        <th width="2%">Edit</th>
      </tr>
      <tr *ngIf="(notes_list | json) == '[]'">
        <td class="text-center" colspan="10">No data to list</td>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of notes_list;let i=index" style="font-size: 12px">
        <td>{{ start + i + 1 }}</td>
        <td>{{ data.TITLE }}</td>
        <td>
          <div [innerHTML]='data.DESCRIPTION | nl2br'></div>
        </td>
        <td>
          <button (click)="editnotes(data);" *ngIf="user_rights.EDIT == '1'" alt="Edit" class="btn btn-sm btn-info"
                  style="font-size: 10px;" title="Edit"><i class="fa fa-edit"></i></button>
        </td>
      </tr>
      </tbody>
    </table>
    <app-pagination (pageChange)="getnotesList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>
  </div>
</div>


